'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchListingAgentsIfNeeded = exports.isListingAgentLoading = exports.getLoadTimeForListingAgent = exports.getListingAgent = exports.LOAD_LISTING_AGENT_SUCCESS = exports.LOAD_LISTING_AGENT_REQUEST = exports.LOAD_LISTING_AGENT_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_LISTING_AGENT_FAIL = exports.LOAD_LISTING_AGENT_FAIL = 'la/domain/listingAgent/LOAD_FAIL';
var LOAD_LISTING_AGENT_REQUEST = exports.LOAD_LISTING_AGENT_REQUEST = 'la/domain/listingAgent/LOAD_REQUEST';
var LOAD_LISTING_AGENT_SUCCESS = exports.LOAD_LISTING_AGENT_SUCCESS = 'la/domain/listingAgent/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_LISTING_AGENT_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.agentIds)
            });
        case LOAD_LISTING_AGENT_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_LISTING_AGENT_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.listingAgents) {
                action.payload.listingAgents.forEach(function (x) {
                    existing[x.agentId] = (0, _extends3.default)({}, x);
                    loaded[x.agentId] = time;
                    loading = (0, _difference2.default)(loading, [x.agentId]);
                });
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.listingAgent;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and passes both params to every function on
// the way down.
var getListingAgent = exports.getListingAgent = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForListingAgent = exports.getLoadTimeForListingAgent = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isListingAgentLoading = exports.isListingAgentLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchListingAgent = function shouldFetchListingAgent(state, agentId) {
    if (!agentId) return false;
    var item = getListingAgent(state, agentId);
    if (item) {
        var loaded = getLoadTimeForListingAgent(state, agentId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isListingAgentLoading(state, agentId);
    return !loading;
};

var whichListingAgentsNeeded = function whichListingAgentsNeeded(state, agentIds) {
    return agentIds.filter(function (agentId) {
        return shouldFetchListingAgent(state, agentId);
    });
};

/* ACTION CREATORS */
var loadListingAgents = function loadListingAgents(agentIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            payload: agentIds,
            type: LOAD_LISTING_AGENT_REQUEST
        });
        return _api.Item.fetchListingAgentsByIds({ agentIds: agentIds, deployment: deployment }).then(function (response) {
            dispatch({
                meta: { actionTime: Date.now(), agentIds: agentIds },
                payload: response.data,
                type: LOAD_LISTING_AGENT_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                meta: { agentIds: agentIds },
                payload: error,
                type: LOAD_LISTING_AGENT_FAIL
            });
        });
    };
};

var fetchListingAgentsIfNeeded = exports.fetchListingAgentsIfNeeded = function fetchListingAgentsIfNeeded(agentIds) {
    return function (dispatch, getState) {
        var needed = whichListingAgentsNeeded(getState(), agentIds);
        if (needed.length) {
            return dispatch(loadListingAgents(needed));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/listingAgent.js
// module id = fuBz
// module chunks = 57